import React from 'react'
import { Link } from "react-router-dom"

function RecentActivityItem({ username, usernameURl, userThumb, activityThumb, assetTitle, assetURL, paraText, time }) {
    return (
        <div className="singleActivityItem">
            <Link to={assetURL}><img src={ activityThumb } alt="" className="ActivityThumb"/></Link>
            <div className="activityInfo">
                <Link to={ usernameURl } ><img src={ userThumb } alt="" className="userProfileThumb"/></Link>
                <p className="InfoData"><Link to={ usernameURl }><b>{ username }</b></Link> { paraText } <Link to={ assetURL }><b>{ assetTitle }</b></Link> <br/> <small className="time">{ time }</small></p>
            </div>
        </div>
    )
}

export default RecentActivityItem
